import { render, staticRenderFns } from "./b-ticket-travel-insurance-traveller-details.vue?vue&type=template&id=618515ec&scoped=true"
import script from "./b-ticket-travel-insurance-traveller-details.vue?vue&type=script&lang=ts&setup=true"
export * from "./b-ticket-travel-insurance-traveller-details.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./b-ticket-travel-insurance-traveller-details.vue?vue&type=style&index=0&id=618515ec&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618515ec",
  null
  
)

export default component.exports